import { observable } from "mobx"

export class MainLayoutViewModel {
  @observable
  public loading = false
}
